/** Operator-facing copy for soft-remove confirms. */
export const removeConfirmMessage = (itemLabel = 'item') =>
  `Remove this ${itemLabel} from the portal and mirrors? It will no longer appear for staff or customers.`;

/** Confirm before deactivating live-visible content. */
export const deactivateConfirmMessage = (itemLabel = 'item') =>
  `Deactivate this ${itemLabel}? It will stop showing on mirrors until you activate it again.`;
